import React, { useState } from "react";

function RightSide() {

    return <div class="foundwords">
        
        <p id="status">Instructions : <br/>Enter word on input and click on check button to start</p>     
</div>;
}

export default RightSide;

